import { l10nError } from "@elsa-zku/lib/helpers/l10nErrors";
import classnames from 'classnames';
import * as React from 'react';
import FieldError from "src/components/Form/components/FieldError";
import style from './FieldWrapper.scss';

export type Props = {
  className?: string,
  labelClassName?: string,
  labelStyle?: 'sm' | 'smb',
  label?: React.ReactNode,
  error?: string,
  errorAbsolute?: boolean,
  children?: React.ReactNode,
  containerTag?: 'div' | 'label',
};

const FieldWrapper: React.FC<Props> = (props) => {
  const {
    className,
    labelClassName,
    labelStyle,
    label,
    error,
    errorAbsolute,
    children,
    containerTag,
  } = props;
  const Container = containerTag || 'label';
  const containerClassName = classnames(
    style.container,
    className,
  );

  return (
    <Container className={containerClassName}>
      {label && <div className={classnames(style.label, labelStyle && style[labelStyle], labelClassName)}>{label}</div>}
      {children}
      {error && (
        <FieldError className={classnames(style.error, errorAbsolute && style.errorAbsolute)}>
          {l10nError(error)}
        </FieldError>
      )}
    </Container>
  );
}

export default React.memo(FieldWrapper);
